import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

export const GetAllOffersTemplatesByType = async ({
  limit,
  page,
  search,
  status = true,
  use_for = "dropdown",
  is_not_shareable = false,
  other_than,
  with_than,
  form_type_uuid,
  code,
  tag,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`query=${search}`);
  if (status) queryList.push(`status=${status}`);
  if (use_for) queryList.push(`use_for=${use_for}`);
  if (form_type_uuid) queryList.push(`type_uuid=${form_type_uuid}`);
  if (code) queryList.push(`code=${code}`);
  if (tag) queryList.push(`tag=${tag}`);

  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/formbuilder/${
      process.env.REACT_APP_VERSION_API
    }/template/list?${queryList.join("&")}`,
    {
      params: {with_than, other_than, is_not_shareable},
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
